module.exports = __webpack_public_path__ + "img/logoColorizedBronze.c8ea2257.png";